module.exports = __webpack_public_path__ + "static/roller-zoom-5a479e18e44bb4608a7a6caaf484cedf.jpg";